import { render, staticRenderFns } from "./minute.vue?vue&type=template&id=1c64a4ca"
import script from "./minute.vue?vue&type=script&lang=js"
export * from "./minute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports